import { render } from "./ProductSlider.vue?vue&type=template&id=cef8c662&scoped=true"
import script from "./ProductSlider.vue?vue&type=script&lang=js"
export * from "./ProductSlider.vue?vue&type=script&lang=js"

import "./ProductSlider.vue?vue&type=style&index=0&id=cef8c662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef8c662"]])

export default __exports__